import { io } from "socket.io-client";
import { WEBSOCKET_URL } from "../utils/config";

const socket = io(WEBSOCKET_URL);

export default socket;
